export const formatNumber = (number: number) => ('0' + number).slice(-2)

export const getColSpan = (
  maxColElements: number = 4,
  minColElements: number = 2,
  totalItems: number
) => {
  if (totalItems === 0) return 4

  const maxRowElements = 4
  let columns = minColElements

  if (totalItems > minColElements) {
    columns = 12 / totalItems > maxRowElements ? maxColElements : totalItems
  }

  const gridColSpan = Math.round(12 / columns)

  return gridColSpan
}

export const getUserInitials = (user: string) => {
  if (!user) return 'UU'
  const nameParts = user.trim().split(' ')
  if (nameParts.length < 2) return user.charAt(0).toUpperCase()

  // Get first name initial (always first word)
  const firstInitial = nameParts[0].charAt(0).toUpperCase()

  // Get first surname initial (middle word for 3+ word names, second word for 2 word names)
  const surnameIndex = Math.floor(nameParts.length / 2)
  const secondInitial = nameParts[surnameIndex].charAt(0).toUpperCase()

  return firstInitial + secondInitial
}
